import React from 'react';
import { MosaicPreset } from '../../../services/central-api/cameras';
import { translate } from '../../../services/translate';
import { View } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';

interface Props {
    zIndex: number;
    labelFontSize?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    disabled: boolean;
    required: boolean;
}

function PresetDropdown({ form, fieldName, zIndex, disabled, required }: Props) {
    return (
        <View style={{ minWidth: 240 }}>
            <FormDropDownPicker
                label={translate('actingBody')}
                items={Object.keys(MosaicPreset).map((key) => ({
                    label: translate(key),
                    value: MosaicPreset[key as keyof typeof MosaicPreset],
                }))}
                multiple={false}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                fieldName={fieldName}
                form={form}
            />
        </View>

    );
}

export default PresetDropdown;
